module.exports = __webpack_public_path__ + "img/full5-min.ca646802.png";